/**
 * @generated SignedSource<<9f83bbe372fc46c5fab7bf8c699c639f>>
 * @relayHash eebdbac5fa654dab9bbe8e50db7862d4
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eebdbac5fa654dab9bbe8e50db7862d4

import { ConcreteRequest } from 'relay-runtime';
export type CommentsModeEnum = "qa" | "standard" | "%future added value";
export type PostStatusEnum = "acfDisabled" | "archived" | "autoDraft" | "dpRewriteRepublish" | "draft" | "future" | "inherit" | "pending" | "private" | "publish" | "requestCompleted" | "requestConfirmed" | "requestFailed" | "requestPending" | "trash" | "%future added value";
export type cskQueryLiveResourceMetadataQuery$variables = {
  nodeId: string;
};
export type cskQueryLiveResourceMetadataQuery$data = {
  readonly node: {
    readonly categories?: ReadonlyArray<{
      readonly path: string;
      readonly slug: string;
      readonly title: string;
    }>;
    readonly comments?: {
      readonly enabled: boolean;
      readonly mode: CommentsModeEnum;
    };
    readonly internalCategories?: ReadonlyArray<{
      readonly slug: string;
    }>;
    readonly originalPublishedAt?: string | null;
    readonly publishedAt?: string | null;
    readonly status?: PostStatusEnum;
    readonly updatedAt?: string | null;
  } | null;
};
export type cskQueryLiveResourceMetadataQuery = {
  response: cskQueryLiveResourceMetadataQuery$data;
  variables: cskQueryLiveResourceMetadataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "nodeId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalPublishedAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "CommentsType",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mode",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "cskQueryLiveResourceMetadataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryResourceType",
                "kind": "LinkedField",
                "name": "categories",
                "plural": true,
                "selections": [
                  (v7/*:: as any*/),
                  (v8/*:: as any*/),
                  (v9/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InternalCategoryResourceType",
                "kind": "LinkedField",
                "name": "internalCategories",
                "plural": true,
                "selections": [
                  (v7/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "FeedContentResourceInterface",
            "abstractKey": "__isFeedContentResourceInterface"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "cskQueryLiveResourceMetadataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryResourceType",
                "kind": "LinkedField",
                "name": "categories",
                "plural": true,
                "selections": [
                  (v7/*:: as any*/),
                  (v8/*:: as any*/),
                  (v9/*:: as any*/),
                  (v10/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InternalCategoryResourceType",
                "kind": "LinkedField",
                "name": "internalCategories",
                "plural": true,
                "selections": [
                  (v7/*:: as any*/),
                  (v10/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "FeedContentResourceInterface",
            "abstractKey": "__isFeedContentResourceInterface"
          },
          (v10/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "eebdbac5fa654dab9bbe8e50db7862d4",
    "metadata": {},
    "name": "cskQueryLiveResourceMetadataQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f22a9fb3904659ee554fa13a1d22fe23";

export default node;
